import { createEmptyWizardProduct } from 'pages/home/ribbon/components/sections/product/components/product-upload-wizard/utils/wizardProduct';

export const WIZARD_ACTIONS = {
  SET_ANSWER: 'SET_ANSWER',
  MERGE_ANSWERS: 'MERGE_ANSWERS',
  RESET_ANSWERS: 'RESET_ANSWERS',
  SET_WIZARD_FORM_ID: 'SET_WIZARD_FORM_ID',
  SET_PRODUCTS: 'SET_PRODUCTS',
  ADD_PRODUCT: 'ADD_PRODUCT',
  UPDATE_PRODUCT: 'UPDATE_PRODUCT',
  REMOVE_PRODUCT: 'REMOVE_PRODUCT',
  SET_DATE: 'SET_DATE',
  GO_NEXT: 'GO_NEXT',
  GO_BACK: 'GO_BACK',
  GO_TO_STEP: 'GO_TO_STEP',
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_ERROR: 'SET_ERROR',
  RESET: 'RESET',
  OPEN_MODAL: 'OPEN_MODAL',
  CLOSE_MODAL: 'CLOSE_MODAL',
  SET_BYPASSED: 'SET_BYPASSED',
  RESTORE_STATE: 'RESTORE_STATE',
  SET_GRID_LOADING: 'SET_GRID_LOADING',
};

export const initialState = {
  currentStep: 'intro',
  history: ['intro'],

  activeModals: {},
  wizardFormId: null,
  isBypassed: false,
  isGridLoading: false,
  answers: {
    productCount: null,
    foodServiceBulkItems: false,
    variableWeight: false,
    alcoholicBeverages: false,
    beer: false,
    wine: false,
    spirits: false,
    sellableInnerPack: false,
    displayShippers: false,
    shelfDisplayBoxTray: false,
    multipacks: false,
    perishable: false,
  },
  products: [],
  arrivalDate: null,
};

export function wizardReducer(state, action) {
  switch (action.type) {
    case WIZARD_ACTIONS.SET_WIZARD_FORM_ID:
      return {
        ...state,
        wizardFormId: action.wizardFormId,
      };

    case WIZARD_ACTIONS.SET_ANSWER:
      return {
        ...state,
        answers: {
          ...state.answers,
          [action.field]: action.value,
        },
      };

    case WIZARD_ACTIONS.MERGE_ANSWERS:
      return {
        ...state,
        answers: {
          ...state.answers,
          ...action.payload,
        },
      };

    case WIZARD_ACTIONS.RESET_ANSWERS:
      return {
        ...state,
        answers: initialState.answers,
      };

    case WIZARD_ACTIONS.SET_PRODUCTS:
      return {
        ...state,
        products: action.products,
      };

    case WIZARD_ACTIONS.ADD_PRODUCT:
      return {
        ...state,
        products: [
          ...state.products,
          action.product || createEmptyWizardProduct(),
        ],
      };

    case WIZARD_ACTIONS.UPDATE_PRODUCT:
      return {
        ...state,
        products: state.products.map((product) =>
          product.uniqueId === action.key
            ? { ...product, [action.field]: action.value }
            : product
        ),
      };

    case WIZARD_ACTIONS.REMOVE_PRODUCT:
      return {
        ...state,
        products: state.products.filter(
          (product) => product.uniqueId !== action.key
        ),
      };

    case WIZARD_ACTIONS.SET_DATE:
      return {
        ...state,
        arrivalDate: action.date,
      };

    case WIZARD_ACTIONS.GO_NEXT:
      return {
        ...state,
        currentStep: action.step,
        history: [...state.history, action.step],
        error: null,
      };

    case WIZARD_ACTIONS.GO_BACK:
      if (state.history.length <= 1) return state;
      const newHistory = state.history.slice(0, -1);
      return {
        ...state,
        currentStep: newHistory[newHistory.length - 1],
        history: newHistory,
        error: null,
      };

    case WIZARD_ACTIONS.GO_TO_STEP:
      return {
        ...state,
        currentStep: action.step,
        history: [...state.history, action.step],
        error: null,
      };

    case WIZARD_ACTIONS.OPEN_MODAL: {
      return {
        ...state,
        activeModals: {
          ...state.activeModals,
          [action.modalName]: true,
        },
      };
    }

    case WIZARD_ACTIONS.CLOSE_MODAL: {
      if (action.modalName) {
        const { [action.modalName]: _, ...restModals } = state.activeModals;
        return {
          ...state,
          activeModals: restModals,
        };
      }
      // Close all modals if no specific modal name provided
      return {
        ...state,
        activeModals: {},
      };
    }

    case WIZARD_ACTIONS.SET_GRID_LOADING:
      return {
        ...state,
        isGridLoading: action.value,
      };

    case WIZARD_ACTIONS.SET_BYPASSED:
      return {
        ...state,
        isBypassed: action.value,
      };

    case WIZARD_ACTIONS.RESTORE_STATE:
      return {
        ...state,
        ...action.payload,
      };

    case WIZARD_ACTIONS.RESET:
      return initialState;

    default:
      console.warn(`Unknown action type: ${action.type}`);
      return state;
  }
}

export default wizardReducer;
